import React from 'react'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import {useWidgetState, useWidgetActions} from '../../hooks/state-provider'
import {hasMoreEvents, isMoreEventsLoading} from '../../selectors/events'
import {Spinner} from '../spinner'
import s from './load-more-button.scss'

export const LoadMoreButton = ({mobile}: {mobile?: boolean}) => {
  const {t} = useTranslation()
  const hasMore = useWidgetState(hasMoreEvents)
  const moreLoading = useWidgetState(isMoreEventsLoading)
  const {loadEventsPage} = useWidgetActions()

  if (!hasMore && !moreLoading) {
    return null
  }

  if (moreLoading) {
    return (
      <div data-hook={DH.loadMoreButtonContainer} className={s.loader}>
        <Spinner />
      </div>
    )
  }

  return (
    <div data-hook={DH.loadMoreButtonContainer} className={classNames(s.container, {[s.mobile]: mobile})}>
      <button data-hook={DH.loadMoreButton} className={s.button} type="button" onClick={() => loadEventsPage()}>
        {t('loadMoreButton')}
      </button>
    </div>
  )
}
